<template>
  <div id="app">
    <vue-toast ref="toast"></vue-toast>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    mounted() {
      this.$event.connect('showToast', this.showToast.bind(this));
      this.$refs.toast.defaultTimeout = 4000;
    },
    methods: {
      showToast(type, text,) {
        this.$refs.toast[type](text)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?868335fc